import React, { FC } from 'react'

import {
  ArrowRightIcon,
  CircleCheckmarkFullIcon,
  IconSizes
} from '@inno-ui/icons'
import { useTranslation } from 'react-i18next'

import styles from './FullTourStepSix.module.scss'
import { TourSignoffItem } from './FullTourStepSix.types'
import monthlySignoffDe from './assets/monthly-signoff-de.webp'
import monthlySignoffEn from './assets/monthly-signoff-en.webp'

export const FullTourStepSix: FC = () => {
  const { i18n, t } = useTranslation('translation', {
    keyPrefix: 'desktop.full_tour.step_six'
  })
  const items = t('items', { returnObjects: true }) as TourSignoffItem[]
  const pathChips = t('path_chips', { returnObjects: true }) as string[]
  const monthlySignoffImage = i18n.language?.startsWith('de')
    ? monthlySignoffDe
    : monthlySignoffEn

  return (
    <section
      className={styles.tourCard}
      role='dialog'
      aria-modal='true'
      aria-labelledby='full-tour-step-six-title'
      aria-describedby='full-tour-step-six-description'
    >
      <div className={styles.tourMain}>
        <div className={styles.tourLeft}>
          <div className={styles.tourHeading}>
            <p className={styles.tourEyebrow}>{t('eyebrow')}</p>
            <h1 id='full-tour-step-six-title' className={styles.tourTitle}>
              <span>{t('title_before')}</span>
              <span className={styles.titleHighlight}>
                {t('title_highlighted')}
              </span>
            </h1>
          </div>

          <div className={styles.tourDetails}>
            <nav className={styles.path} aria-label={t('path_label')}>
              {pathChips.map((chip, index) => (
                <React.Fragment key={chip}>
                  {index > 0 && (
                    <ArrowRightIcon
                      aria-hidden='true'
                      color='var(--white)'
                      size={IconSizes.Size16}
                    />
                  )}
                  <span className={styles.pathChip}>{chip}</span>
                </React.Fragment>
              ))}
            </nav>

            <ul
              id='full-tour-step-six-description'
              className={styles.tourItems}
            >
              {items.map(item => (
                <li key={item.label} className={styles.tourItem}>
                  <CircleCheckmarkFullIcon
                    aria-hidden='true'
                    color='#BAE281'
                    size={IconSizes.Size18}
                  />
                  <span>
                    <strong>{item.label}</strong> {item.description}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className={styles.visualColumn}>
          <div className={styles.visualCard}>
            <div className={styles.preview}>
              <img
                src={monthlySignoffImage}
                alt={t('image_alt')}
                className={styles.previewImage}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
